import { EMessagesActionTypes, IMessagesReadResponse, TMessagesErrorPayload, TMessageListPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Пометить сообщения как прочитанные
 */
export const setMessagesAsRead = actionGenerator<EMessagesActionTypes.SetAsRead, IMessagesReadResponse>(
  EMessagesActionTypes.SetAsRead,
);

/**
 * Состояние загрузки сообщений
 */
export const setMessagesPending = actionGenerator<EMessagesActionTypes.SetMessagesPending, { chatId: string }>(
  EMessagesActionTypes.SetMessagesPending,
);

/**
 * Успешная загрузка сообщений
 */
export const setMessagesFulfilled = actionGenerator<EMessagesActionTypes.SetMessagesFulfilled, TMessageListPayload>(
  EMessagesActionTypes.SetMessagesFulfilled,
);

/**
 * Ошибка загрузки сообщений
 */
export const setMessagesFailed = actionGenerator<EMessagesActionTypes.SetMessagesFailed, TMessagesErrorPayload>(
  EMessagesActionTypes.SetMessagesFailed,
);
